// export const apiUrl = 'http://localhost:5000/api'
const host = window.location.hostname
const prefix = host === 'localhost' ? 'http://' : 'https://'
const port = host === 'localhost' ? ':5001' : ''
export const apiUrl = `${prefix}${host}${port}/api`
// export const apiUrl = `${prefix}${host}/api`
// export const apiUrl = 'https://moystat.ru/api'
// export const apiUrl = 'https://moyself-auth804.herokuapp.com/api'
